import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpExperienceVettingSaveMerchCopyOptions,
	httpExperienceVettingSaveMerchCopy
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useExperienceVettingSaveMerchCopy = (
	urlParams: HttpExperienceVettingSaveMerchCopyOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpExperienceVettingSaveMerchCopyOptions['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpExperienceVettingSaveMerchCopy({
				urlParams,
				payload,
				params: {
					responseType: 'extended'
				}
			}),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
